module.exports = __webpack_public_path__ + "static/media/122.853d4a30.png";